import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {IPhase, Project} from 'types/project';
import {ResponseData} from 'types/response-data';

const storeProjectPhases = api.injectEndpoints({
  endpoints: builder => ({
    storeProjectPhases: builder.mutation<Response, StoreProjectPhasesRequest>({
      query: (body: StoreProjectPhasesRequest) => {
        return {
          method: 'POST',
          url: `projects/${body.id}/phases`,
          body,
        };
      },
    }),
  }),
});

export type StoreProjectPhasesRequest = {
  id: string | undefined;
  phases: IPhase[];
  phase_global_comment?: string;
  deleted_records: {
    phases?: ObjectId[];
    deposits?: ObjectId[];
  };
};

type Response = ResponseData<{
  phases: Array<IPhase>;
  phase_global_comment?: string;
}>;

export const {useStoreProjectPhasesMutation} = storeProjectPhases;
